import React, { useEffect, useState } from "react";
import {
  Button,
  Dialog,
  Card,
  CardBody,
  CardFooter,
  Typography,
  Input,
  Select,
  Option,
} from "@material-tailwind/react";
import api from "../../api/api";
import { toast } from "react-toastify";
import XCircleIcon from "@heroicons/react/24/solid/XCircleIcon";

import { nanoid } from "nanoid";

export default function AddProduct() {
  const [open, setOpen] = useState(false);
  const [image, setImage] = useState(null);
  const [categories, setCategories] = useState([]);
  const [suppliers, setSuppliers] = useState([]);
  const [isLoadingData, setIsLoadingData] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const handleOpen = () => setOpen((cur) => !cur);

  const [product, setProduct] = useState({
    id: nanoid(),
    name: "",
    description: "",
    category_id: "",
    supplier_id: "",
    stock_quantity: 0,
  
    price: 0,
    image: "",
  });

  const [fields] = useState([
    { label: "Nom de l'article", name: "name", type: "text" },
    { label: "Description", name: "description", type: "text" },

    { label: "Prix", name: "price", type: "number" },
    { label: "Quantité en stock", name: "stock_quantity", type: "number" },
    { label: "Fournisseur", name: "supplier_id", type: "select_Supplier" },
    { label: "Categorie", name: "category_id", type: "select_Category" },
    { label: "Image", name: "image", type: "file" },
  ]);

  const loadFormData = async () => {
    setIsLoadingData(true);
    try {
      const [categoriesRes, suppliersRes] = await Promise.all([
        api.get("/products/categories"),
        api.get("/products/suppliers")
      ]);
      setCategories(categoriesRes.data ?? []);
      setSuppliers(suppliersRes.data.suppliers ?? []);
    } catch (error) {
      toast.error("Erreur lors du chargement des données du formulaire.");
    } finally {
      setIsLoadingData(false);
    }
  };

  useEffect(() => {
    loadFormData();
  }, []);

  // console.log("fields", fields);

  const handleChange = (e) => {
    // console.log("e.target", e.target.files);
    const { name, value } = e.target;

    setProduct({
      ...product,
      [name]: value,
    });

    // console.log("image==>", image);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (
      !product.name ||
      !product.description ||
      !product.category_id ||
      !product.supplier_id
    ) {
      toast.error("Tous les champs sont require.");
      return;
    }

    setIsSubmitting(true);
    const formData = new FormData();

    formData.append("name", product.name);
    formData.append("description", product.description);
    formData.append("price", product.price);
    formData.append("stock_quantity", product.stock_quantity);
    formData.append("unit", 'Fcfa');
    formData.append("supplier_id", product.supplier_id);
    formData.append("category_id", product.category_id);
    formData.append("image", image);

    try {
      await api.post("products", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      toast.success("Produit ajouté avec succès");
      handleOpen();
    } catch (error) {
      toast.error("Erreur lors de l'ajout du produit. Veuillez réessayer.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <Button className="shadow-none" onClick={handleOpen}>
        Ajouter un article
      </Button>
      <Dialog
        size="xs"
        open={open}
        handler={handleOpen}
        className="bg-transparent shadow-none"
      >
        <Card className="mx-auto w-full max-w-[2xl]">
          <form onSubmit={handleSubmit}>
            <CardBody className="flex flex-col gap-3 ">
              <Typography
                variant="h3"
                color="blue-gray"
                className="text-center border-b"
              >
                Ajouter un article
              </Typography>
              <XCircleIcon
                className="block h-6 w-6 absolute top-3 right-3 cursor-pointer"
                aria-hidden="true"
                onClick={handleOpen}
              />

              {fields.map((input, index) => (
                <div className="" key={index}>
                  <Typography className="block text-gray-700 font-bold mb-2">
                    {input.label}:
                  </Typography>

                  {(() => {
                    switch (input.type) {
                      case "file":
                        return (
                          <input
                            type={input.type}
                            name={input.name}
                            // value={product[input.name]}
                            onChange={(e) => setImage(e.target.files[0])}
                            className="file-input file-input-bordered w-full "
                          />
                        );
                      case "select_Category":
                        return (
                          <Select
                            label="Selectionné une catégories"
                            className="w-full bg-transparent input input-bordered"
                            animate={{
                              mount: { y: 0 },
                              unmount: { y: 25 },
                            }}
                            name={input.name}
                            value={input.category_id}
                            onChange={(e) =>
                              setProduct({ ...product, category_id: e })
                            }
                          >
                            {categories.map((item) => (
                              <Option key={item.id} value={item.id}>
                                {item.name}
                              </Option>
                            ))}
                          </Select>
                        );
                      case "select_Supplier":
                        return (
                          <Select
                            label="Selectionné un supplier"
                            className="w-full bg-transparent input input-bordered"
                            animate={{
                              mount: { y: 0 },
                              unmount: { y: 25 },
                            }}
                            name={input.name}
                            value={input.category_id}
                            onChange={(e) =>
                              setProduct({ ...product, supplier_id: e })
                            }
                          >
                            {suppliers.map((item) => (
                              <Option key={item.id} value={item.id}>
                                {item.name}
                              </Option>
                            ))}
                          </Select>
                        );
                      default:
                        return (
                          <Input
                            type={input.type}
                            name={input.name}
                            label={`${input.label}`}
                            value={product[input.name]}
                            onChange={handleChange}
                          />
                        );
                    }
                  })()}
                </div>
              ))}

              <div className="border-b"></div>
            </CardBody>
            <CardFooter className="pt-0 ">
              <Button
                type="submit"
                variant="gradient"
                fullWidth
                className="p-4 shadow-0 flex items-center justify-center gap-2"
                disabled={isSubmitting || isLoadingData}
              >
                {isSubmitting && (
                  <svg className="animate-spin h-5 w-5" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
                  </svg>
                )}
                {isSubmitting ? "Ajout en cours..." : "Ajouter"}
              </Button>
            </CardFooter>{" "}
          </form>
        </Card>
      </Dialog>
    </>
  );
}
